import { AttackPattern, PatternState } from '../AttackPattern.js';

/**
 * The First Silence (The Undersong, Act II — desperation finale). The survival
 * window at the end of the world. It fights in near-total dark — the finale's
 * Gloaming is at its smallest radius by now (max phase), and the Ballast well
 * is live — so this pattern only needs to supply slow, fair bullet content to
 * survive in that dark: a slow full ring plus a couple of aimed shots each
 * cycle, re-begun by SpawningSystem until the desperation timer runs out.
 *
 * Deliberately slow and sparse: you cannot see far, so the threat has to be
 * readable by the time it reaches your small circle of light.
 */
export class FirstSilence extends AttackPattern {
  constructor({ minPhase = 0, config }) {
    super({ name: 'The First Silence', telegraphDuration: 0.6, activeDuration: 2.0, minPhase });
    this.config = config;
  }

  onActiveStart(boss, player, pool) {
    const { ringCount, ringSpeed, ringDamage, aimedShots, aimedSpeed, aimedDamage } = this.config;
    const base = Math.random() * Math.PI * 2;
    for (let i = 0; i < ringCount; i++) {
      const angle = base + (i / ringCount) * Math.PI * 2;
      pool.fire({
        x: boss.x,
        y: boss.y,
        vx: Math.cos(angle) * ringSpeed,
        vy: Math.sin(angle) * ringSpeed,
        radius: 2.8,
        damage: ringDamage,
        color: '#e0e6ff',
        lifetime: 6,
      });
    }
    const aim = Math.atan2(player.y - boss.y, player.x - boss.x);
    for (let i = 0; i < aimedShots; i++) {
      const angle = aim + (i - (aimedShots - 1) / 2) * 0.16;
      pool.fire({
        x: boss.x,
        y: boss.y,
        vx: Math.cos(angle) * aimedSpeed,
        vy: Math.sin(angle) * aimedSpeed,
        radius: 3,
        damage: aimedDamage,
        color: '#ffffff',
        lifetime: 5,
      });
    }
  }

  getVisual(boss) {
    if (this.state !== PatternState.TELEGRAPH) return null;
    return {
      kind: 'silencePreview',
      x: boss.x,
      y: boss.y,
      ringCount: this.config.ringCount,
      color: '#e0e6ff',
    };
  }
}
